import { converteDateToSql } from "../Generics/Helps"

export class RegisterEntity {
  id: number

  lastUpdate: string

  description: string

  employeeEditeId: string

  constructor(data: Partial<RegisterEntity> = {}) {
    this.id = data.id ?? -1

    this.lastUpdate = data.lastUpdate ?? converteDateToSql(new Date())

    this.description = data.description ?? ""

    this.employeeEditeId = data.employeeEditeId ?? ""
  }
}
